import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-rating', 'rating-singular', 'žvaigždutė');
Labels.set('ui-rating', 'rating-plural', 'žvaigždutės');
